import {
  LOGIN,
  LOGOUT,
  USER_DETAILS,
  OPEN_LOGIN_MODAL,
  SET_ADMIN_ID,
  ADMITCARD_DETAILS
} from "./constant";

const initial_state = {
  user_details: [],
  email: "",
  isHome: true,
  token: "",
  password: "",
  mobile: "",
  organization_id: "",
  admin_id: "",
  type: "",
  profile_img: "",
  mobileOpen: false,
  user_id: "",
  company_id: "",
  registration: [],
  admitcard_details: [],
  loginModal: false,
  successfull: false,
  otpmodal: false,
  user_token: "",
  department_id: "",
  department_name: "",
  active: false,
  name: ""
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case LOGIN:
      return { ...state, isHome: false, user_id: action.payload._id, type: action.payload.type };
    case LOGOUT:
      return { ...state, isHome: true, user_id: "", type: "" };
    case OPEN_LOGIN_MODAL:
      return { ...state, loginModal: true };
    case SET_ADMIN_ID:
      return { ...state, admin_id: action.payload };
    case USER_DETAILS:
      return { ...state, user_details: action.payload };
    case ADMITCARD_DETAILS:
      return { ...state, admitcard_details: action.payload };
    default:
      return state;
  }
}
